<style lang="scss" scoped>
.app-page {
  height: 100%;
}
</style>
<template>
  <section class="app-page">
    <!-- 头部 -->
    <navbar />
    <!-- 主体部分 -->

    <app-main />

    <!-- 尾部 -->
    <footer-page v-if="showFooter" />

    <!-- 发布文章 -->
    <articleModel ref="articleDialog" :tt_id="thumbsId" :classData="tablist" @post-submitted="handlePostSubmitted" />

    <!-- 发布帖子 -->
    <postModel ref="postDialog" :data="data_list" @post-submitted="handlePostModelSubmitted" />

  </section>
</template>

<script>
// import { mapGetters, mapActions } from 'vuex';
import AppMain from "./components/AppMain";
import Navbar from "./components/Navbar";
import FooterPage from "./components/FooterPage";

// 发布帖子弹框
import postModel from '@/components/postModel.vue';
// 文章投稿
import articleModel from '@/components/articleModel.vue';

import { gettopicList, getcommonData } from "@api/home";

import { setArticleAdd } from "@api/active";

import { addApipost } from "@api/home";

export default {
  name: "Layout",
  components: {
    AppMain,
    Navbar,
    FooterPage, articleModel, postModel
  },
  computed: {
    // ...mapGetters() // 使用命名空间访问 home 模块的 datalist getter

    // ...mapState('home', ['datalist'])

  },

  data() {
    return {
      // 文章
      thumbsId: "",
      tablist: [],

      data_list: {},

      showFooter: true,
    }
  },
  created() {
    // 在页面创建时，根据需要决定是否显示footer
    this.showFooter = this.shouldShowFooter();
  },
  async mounted() {
    // 设置默认的文章类型  --  默认选择第一个

    let res = await gettopicList();
    if (res.status == 200) {
      this.tablist = res.data.topic_list.map((item) => {
        return { tt_title: item.tt_title, tt_id: item.tt_id }
      })
      if (this.tablist.length > 0) {
        this.thumbsId = this.tablist[0].tt_id;
      }
    }


    this.$bus.$on('openModalflog', (data) => {
      if (data == 1) {
        this.getarticle();
      } else if (data == 2) {
        this.getPost()
      } else {

      }
    });

  },


  methods: {

    shouldShowFooter() {
      // 这里可以根据路由或其他条件判断是否需要显示footer
      // 例如，通过路由的meta字段来控制
      return !this.$route.meta.hideFooter;
    },



    async getPost() {
      let res = await getcommonData();
      if (res.status == 200) {
        this.data_list = res.data;
      }

      this.$refs.postDialog.openModal();
    },

    // 获取文章类型数据
    async getarticle() {
      let res = await gettopicList();
      if (res.status == 200) {
        this.tablist = res.data.topic_list.map((item) => {
          return { tt_title: item.tt_title, tt_id: item.tt_id }
        })
        if (this.tablist.length > 0) {
          this.thumbsId = this.tablist[0].tt_id;
        }
      }
      this.$refs.articleDialog.openModal();
    },

    // 发文章
    async handlePostSubmitted(content) {


      let res = await setArticleAdd(content);
      if (res.status == 200) {
        this.$message.success(res.msg);
      }
    },

    // 发布帖子

    async handlePostModelSubmitted(content) {

      let res = await addApipost(content);
      if (res.status == 200) {
        this.$message.success(res.msg);
      }

    }

  },
};
</script>
